// Message d'un upload refusé sans detail de l'API ; les écrans le passent en repli à apiErrorMessage
export const UPLOAD_FAILED_MESSAGE = "Une erreur est survenue lors du téléchargement du fichier. Veuillez réessayer.";
